import * as React from 'react';
import styled from 'styled-components';
import {BREAKPOINTS, COLORS} from '../styles';
import {PageWidth} from '../Layouts';

export const OverviewBannerWrapperStyles = styled.div`
  background-color: ${props => COLORS.getColor('primary_20', props.theme)};
`;

export const OverviewBannerContentStyles = styled(PageWidth)`
  background-color: ${props => COLORS.getColor('primary_20', props.theme)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  ${BREAKPOINTS.MEDIUM} {
    flex-direction: row;
    padding: 48px 12px;
  }

  & > *:first-child {
    padding-top: 12px;
    width: 320px;
    height: 180px;

    ${BREAKPOINTS.MEDIUM} {
      padding-top: 0;
      margin-right: 20px;
      width: 384px;
      height: 216px;
    }
  }

  & h2, h3, h4, h5, h6 {
    margin: 16px 0 24px 0;
  }

  & p {
    margin: 0;
    padding: 0 0 28px 0;
    max-width: 310px;
  }

  & div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 18px;

    ${BREAKPOINTS.MEDIUM} {
      margin-left: 20px;
      align-items: start;
      justify-content: start;
      width: 384px;
    }
  }
`;

export type OverviewBannerProps = { children: any; testId?: string } & React.HTMLAttributes<HTMLDivElement>;

const OverviewBanner = ({ children, testId, ...rest }: OverviewBannerProps) => {
  return (
    <OverviewBannerWrapperStyles {...rest}>
      <OverviewBannerContentStyles data-testid={testId}>{children}</OverviewBannerContentStyles>
    </OverviewBannerWrapperStyles>
  );
};

export default OverviewBanner;
